import React from 'react';
import { GET_REQUESTED_ITEM_BY_ID } from '../api';
import { useQuery } from '@apollo/client';
import Navbar from '../../../components/Navbar';
import EditRequestedItemForm from '../../../components/RequestForms/EditRequestedItemForm';
import { Loader } from '../../../components/Loader';
import { ErrorMessage } from '../../../components/ErrorMessage';

export const EditRequestedItemPage = (props) => {
  const { loading, error, data } = useQuery(GET_REQUESTED_ITEM_BY_ID, {
    variables: { id: parseInt(props.match.params.requestedItemId) },
  });
  if (loading)
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  if (error) {
    return <ErrorMessage title='Error: EditRequestedItemPage'/>;
  }
  if (data) {
    return (
      <div>
        <Navbar />
        <div className='m-4'>
          <EditRequestedItemForm data={data} queryData={data} />
        </div>
      </div>
    );
  }
};
